import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-editcategory',
  templateUrl: './editcategory.component.html',
  styleUrls: ['./editcategory.component.css']
})
export class EditcategoryComponent implements OnInit {

  category: Productcategory;
  categoryid: string;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(private productServices: ProductService, private router: Router, private route: ActivatedRoute) {
    this.category = new Productcategory;
    this.category.storeId = 1;
    this.categoryid = this.route.snapshot.params.catid;
  }

  ngOnInit() {
    //alert(this.categoryid);
    this.getCategoryById();

    this.dropdownList = [
      { item_id: 1, item_text: 'Canada' },
      { item_id: 2, item_text: 'US' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  getCategoryById() {
    this.productServices.getCategoryById(this.categoryid).subscribe(
      (data: any) => {
        this.category = data;
        console.log(this.category);
        debugger;
        var storeidstr = this.category.storeId.toString();
        //var storeidarr = storeidstr.split(",");

        if (storeidstr == "1") {
          this.selectedItems = [{ item_id: 1, item_text: 'Canada' }];
        }
        if (storeidstr == "2") {
          this.selectedItems = [{ item_id: 2, item_text: 'US' }];
        }
        if (storeidstr == "1,2") {
          this.selectedItems = [{ item_id: 1, item_text: 'Canada' }, { item_id: 2, item_text: 'US' }];
        }
        if (storeidstr == "2,1") {
          this.selectedItems = [{ item_id: 2, item_text: 'US' }, { item_id: 1, item_text: 'Canada' }];
        }

        // this.selectedItems = [
        //   { item_id: 1, item_text: 'Canada' }
        // ];
      });
  }

  UpdateProductCategory(form: NgForm) {
    console.log(form.value);
    var tempstoreid = [];
    if (form.value.storeId.length > 0) {
      form.value.store = [];
      for (var i = 0; i < form.value.storeId.length; i++) {
        if (form.value.storeId[i].item_id == "1") {
          form.value.store[i] = "Canada";
          tempstoreid[i] = "1"
        }
        else if (form.value.storeId[i].item_id == "2") {
          form.value.store[i] = "US";
          tempstoreid[i] = "2"
        }
        else { }
      }
      //alert(form.value.store);
      form.value.store = form.value.store.join();
      //form.value.storeId = form.value.storeId.join();
      form.value.storeId = tempstoreid.join();
      form.value.id = this.categoryid;
      console.log(form.value);
      this.productServices.UpdateCategory(form.value)
        .subscribe((data: any) => {
          if (data == true) {
            //alert("saved");
            this.router.navigate(['/categorylist']);
          }
          else {
            alert("category already exist");
          }
        });
    }
    else {
      alert("please select location");
    }

  }

}
